import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Modal, NavLink, CloseButton } from "react-bootstrap";

const ButtonModalPlaceholderVideo = ({ btnTitle, btnDescription, btnIcon, modalTitle, modalIcon, placeholderData, modalClassName }) => {
    const [placeholderModalShow, setPlaceholderModalShow] = useState(false);
    return (placeholderData) &&
        <>
            <NavLink onClick={() => setPlaceholderModalShow(true)} style={{ textDecoration: "none" }} className="status-wifi">
                <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
                    <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
                        <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <FontAwesomeIcon icon={btnIcon} color="#FFF" style={{ fontSize: 14 }} />
                        </div>
                        <div className="text-left">
                            <p className="mb-0">
                                <b style={{ color: "#555555" }}>{btnTitle}</b>
                            </p>
                            <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                                {btnDescription}
                            </p>
                        </div>
                    </div>
                </div>
            </NavLink>

            <Modal
                show={placeholderModalShow}
                onHide={() => setPlaceholderModalShow(false)}
                className={"info-modal " + modalClassName}
            >
                <Modal.Header>
                    {modalTitle}
                    <CloseButton onClick={() => setPlaceholderModalShow(false)} />
                </Modal.Header>
                <Modal.Body className="p-0">
                    <iframe
                        width="100%"
                        height="100%"
                        className="embed-responsive-item"
                        style={{ background: "#000", border: "none" }}
                        src={placeholderData}
                        title="Video"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                    ></iframe>
                </Modal.Body>
            </Modal>
        </>
}


export default ButtonModalPlaceholderVideo;
